class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    
  }
  static renderReview() {
    if (window.SPR && theme.review ) {
      if ($('.shopify-product-reviews-badge').length > 0) {
        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
      };
    }
  }
  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const getpagi = document.querySelector('.AjaxinatePagination');
    
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      const elem = getpagi.getAttribute('data-pagination');
      var endlessScroll = new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: elem == 'scroll' ? 'scroll' : 'click'
      });
    }
    theme.wishlist.load();
    theme.compare.load();
    theme.countdown.load();
    theme.swatchCard2.load();
    FacetFiltersForm.renderReview();
    
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this._initialized = false;
    this._connected = false;
    this._initFrame = null;
    this._syncTimers = [];
    this._probeObserver = null;
    this._sliderInstance = null;
    this._currencyItems = [];
    this._currentCurrency = 'AED';
    this._rate = 1;

    this._onCurrencyClick = this.onCurrencyClick.bind(this);
    this._onCurrencyEvent = this.onCurrencyEvent.bind(this);
  }

  connectedCallback() {
    if (this._connected) return;
    this._connected = true;

    this._initFrame = window.requestAnimationFrame(() => {
      if (!this.isConnected) return;
      this.initialize();
    });
  }

  disconnectedCallback() {
    this._connected = false;

    if (this._initFrame) {
      window.cancelAnimationFrame(this._initFrame);
      this._initFrame = null;
    }

    this.clearSyncTimers();

    if (this._probeObserver) {
      this._probeObserver.disconnect();
      this._probeObserver = null;
    }

    document.removeEventListener('click', this._onCurrencyClick, true);

    ['currencyChanged', 'currency:change', 'bacurr:change', 'nova:currency:change']
      .forEach((eventName) => {
        document.removeEventListener(eventName, this._onCurrencyEvent);
      });

    this._initialized = false;
  }

  initialize() {
    if (this._initialized) return;

    this.rangeInput = this.querySelector('.sliderFilter');
    this.displayMinInput = this.querySelector('.field__input_min');
    this.displayMaxInput = this.querySelector('.field__input_max');

    if (!this.rangeInput || !this.displayMinInput || !this.displayMaxInput) return;

    this._initialized = true;

    this.baseRangeMin = this.toNumber(this.rangeInput.dataset.min);
    this.baseRangeMax = this.toNumber(this.rangeInput.dataset.max);

    if (!Number.isFinite(this.baseRangeMin)) this.baseRangeMin = 0;

    if (!Number.isFinite(this.baseRangeMax)) {
      this.baseRangeMax = this.toNumber(this.displayMaxInput.getAttribute('max'));
    }

    if (!Number.isFinite(this.baseRangeMax)) this.baseRangeMax = 0;

    this.createBaseInputs();
    this.captureCurrencyElements();
    this.createNovaProbe();
    this.bindDisplayInputs();
    this.bindCurrencyListeners();
    this.initializeSlider();

    const initialCurrency = this.detectCurrency() || 'AED';
    this._currentCurrency = initialCurrency;
    this.updateCurrencySymbols();

    if (initialCurrency === 'AED') {
      this.applyCurrency('AED', 1);
    }

    this.requestNovaRefresh();
  }

  createBaseInputs() {
    const existingMin = this.querySelector('.x-nova-price-base-min');
    const existingMax = this.querySelector('.x-nova-price-base-max');

    if (existingMin && existingMax) {
      this.baseMinInput = existingMin;
      this.baseMaxInput = existingMax;
      return;
    }

    this.baseMinInput = document.createElement('input');
    this.baseMinInput.type = 'hidden';
    this.baseMinInput.className = 'x-nova-price-base-min';
    this.baseMinInput.name = this.displayMinInput.getAttribute('name') || '';
    this.baseMinInput.value = this.displayMinInput.value || '';

    this.baseMaxInput = document.createElement('input');
    this.baseMaxInput.type = 'hidden';
    this.baseMaxInput.className = 'x-nova-price-base-max';
    this.baseMaxInput.name = this.displayMaxInput.getAttribute('name') || '';
    this.baseMaxInput.value = this.displayMaxInput.value || '';

    this.displayMinInput.removeAttribute('name');
    this.displayMaxInput.removeAttribute('name');

    this.displayMinInput.classList.add('x-nova-price-display-min');
    this.displayMaxInput.classList.add('x-nova-price-display-max');

    this.displayMinInput.setAttribute('step', 'any');
    this.displayMaxInput.setAttribute('step', 'any');

    this.displayMinInput.insertAdjacentElement('afterend', this.baseMinInput);
    this.displayMaxInput.insertAdjacentElement('afterend', this.baseMaxInput);
  }

  captureCurrencyElements() {
    this._currencyItems = Array.from(
      this.querySelectorAll('[data-nova-filter-currency], .nova-filter-currency')
    );
  }

  createNovaProbe() {
    let probe = this.querySelector('.x-nova-price-probe');

    if (!probe) {
      probe = document.createElement('span');
      probe.className = 'x-nova-price-probe';
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = [
        'position:absolute!important',
        'width:1px!important',
        'height:1px!important',
        'padding:0!important',
        'margin:-1px!important',
        'overflow:hidden!important',
        'clip:rect(0,0,0,0)!important',
        'white-space:nowrap!important',
        'border:0!important',
        'pointer-events:none!important'
      ].join(';');

      const money = document.createElement('span');
      money.className = 'money';
      money.textContent = '100.00 AED';

      probe.appendChild(money);
      this.appendChild(probe);
    }

    this.probe = probe;
    this.probeMoney = probe.querySelector('.money') || probe;

    this._probeObserver = new MutationObserver(() => {
      this.scheduleNovaSync(0);
    });

    this._probeObserver.observe(this.probe, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  bindDisplayInputs() {
    this.displayMinInput.addEventListener('input', () => {
      this.updateBaseFromDisplay();
      this.updateInputLimits();
      this.updateSliderFromDisplay();
    });

    this.displayMaxInput.addEventListener('input', () => {
      this.updateBaseFromDisplay();
      this.updateInputLimits();
      this.updateSliderFromDisplay();
    });

    this.displayMinInput.addEventListener('change', () => {
      this.clampDisplayInputs();
      this.updateBaseFromDisplay();
      this.updateInputLimits();
      this.updateSliderFromDisplay();
    });

    this.displayMaxInput.addEventListener('change', () => {
      this.clampDisplayInputs();
      this.updateBaseFromDisplay();
      this.updateInputLimits();
      this.updateSliderFromDisplay();
    });
  }

  bindCurrencyListeners() {
    document.addEventListener('click', this._onCurrencyClick, true);

    ['currencyChanged', 'currency:change', 'bacurr:change', 'nova:currency:change']
      .forEach((eventName) => {
        document.addEventListener(eventName, this._onCurrencyEvent);
      });
  }

  onCurrencyClick(event) {
    if (!event.target || !event.target.closest) return;

    const currencyItem = event.target.closest(
      '.currMovers, .bacurr-dropdown-choices li, [id^="baCountry-"], [data-currency]'
    );

    if (!currencyItem) return;

    const code = this.currencyFromElement(currencyItem);
    if (code) {
      this._pendingCurrency = code;
      this.saveSelectedCurrency(code);
    }

    this.scheduleNovaSync(80);
    this.scheduleNovaSync(250);
    this.scheduleNovaSync(700);
    this.scheduleNovaSync(1400);
  }

  onCurrencyEvent(event) {
    const detail = event && event.detail ? event.detail : {};
    const code = this.normalizeCurrency(
      detail.currency || detail.code || detail.selectedCurrency || detail.value
    );

    if (code) {
      this._pendingCurrency = code;
      this.saveSelectedCurrency(code);
    }

    this.scheduleNovaSync(50);
    this.scheduleNovaSync(250);
    this.scheduleNovaSync(700);
  }

  saveSelectedCurrency(code) {
    try {
      window.localStorage.setItem('xbrandat_nova_selected_currency', code);
    } catch (error) {}
  }

  requestNovaRefresh() {
    const runNova = () => {
      try {
        if (
          window.baCurr &&
          typeof window.baCurr.rePeat === 'function'
        ) {
          window.baCurr.rePeat();
        }
      } catch (error) {}

      this.syncFromNova();
    };

    window.setTimeout(runNova, 50);
    this.scheduleNovaSync(200);
    this.scheduleNovaSync(600);
    this.scheduleNovaSync(1200);
    this.scheduleNovaSync(2200);
  }

  scheduleNovaSync(delay) {
    const timer = window.setTimeout(() => {
      this._syncTimers = this._syncTimers.filter((item) => item !== timer);

      if (!this.isConnected) return;
      this.syncFromNova();
    }, delay);

    this._syncTimers.push(timer);
  }

  clearSyncTimers() {
    this._syncTimers.forEach((timer) => window.clearTimeout(timer));
    this._syncTimers = [];
  }

  syncFromNova() {
    if (!this.probeMoney) return;

    const currency = this._pendingCurrency || this.detectCurrency();

    if (currency === 'AED') {
      this._pendingCurrency = '';
      this.applyCurrency('AED', 1);
      return;
    }

    const probeText = String(this.probeMoney.textContent || '').trim();
    const probeCurrency = this.currencyFromText(probeText);
    const probeValue = this.parseMoneyNumber(probeText);

    if (probeCurrency === 'AED') {
      return;
    }

    if (probeCurrency && probeCurrency !== currency) {
      return;
    }

    if (!Number.isFinite(probeValue) || probeValue <= 0) {
      return;
    }

    if (!probeCurrency && Math.abs(probeValue - 100) < 0.000001) {
      return;
    }

    const rate = probeValue / 100;

    if (!Number.isFinite(rate) || rate <= 0) return;

    this._pendingCurrency = '';
    this.applyCurrency(currency, rate);
  }

  applyCurrency(currency, rate) {
    if (!currency || !Number.isFinite(rate) || rate <= 0) return;

    this._currentCurrency = currency;
    this._rate = rate;

    this.updateCurrencySymbols();
    this.updateDisplayFromBase();
    this.updateInputLimits();
    this.updateSliderRange();
    this.updateMaxPriceInfo();
  }

  detectCurrency() {
    const activeSelectors = [
      '.currMovers.active',
      '.currMovers.selected',
      '.currMovers.current',
      '.currMovers.is-active',
      '.currMovers[aria-selected="true"]',
      '.bacurr-dropdown-choices li.active',
      '.bacurr-dropdown-choices li.selected',
      '.bacurr-dropdown-choices li.current',
      '[id^="baCountry-"][class*="active"]',
      '[data-currency].active',
      '[data-currency].selected',
      '[data-currency][aria-selected="true"]'
    ];

    for (let index = 0; index < activeSelectors.length; index += 1) {
      const element = document.querySelector(activeSelectors[index]);
      const code = this.currencyFromElement(element);
      if (code) return code;
    }

    try {
      const saved = this.normalizeCurrency(
        window.localStorage.getItem('xbrandat_nova_selected_currency')
      );

      if (saved) return saved;
    } catch (error) {}

    try {
      if (window.baCurr && window.baCurr.config) {
        const config = window.baCurr.config;
        const candidates = [
          config.current_currency,
          config.selected_currency,
          config.currency,
          config.final_currency,
          config.user_curr
        ];

        for (let index = 0; index < candidates.length; index += 1) {
          const code = this.normalizeCurrency(candidates[index]);
          if (code) return code;
        }
      }
    } catch (error) {}

    const probeCode = this.currencyFromText(
      this.probeMoney ? this.probeMoney.textContent : ''
    );

    if (probeCode) return probeCode;

    return this._currentCurrency || 'AED';
  }

  currencyFromElement(element) {
    if (!element) return '';

    const values = [
      element.id,
      element.getAttribute('rel'),
      element.getAttribute('data-currency'),
      element.getAttribute('data-value'),
      element.getAttribute('value'),
      element.getAttribute('aria-label'),
      element.textContent
    ];

    for (let index = 0; index < values.length; index += 1) {
      const code = this.normalizeCurrency(values[index]);
      if (code) return code;
    }

    return '';
  }

  normalizeCurrency(value) {
    let raw = String(value || '').trim().toUpperCase();

    const direct = raw.match(/\b(AED|USD|SAR|EGP|LBP|JOD)\b/);
    if (direct) return direct[1];

    if (/US\$|\$/.test(raw)) return 'USD';
    if (/L£/.test(raw)) return 'LBP';
    if (/E£/.test(raw)) return 'EGP';
    if (/د\s*[.٫]?\s*إ/.test(raw)) return 'AED';
    if (/د\s*[.٫]?\s*(?:أ|ا)/.test(raw)) return 'JOD';
    if (/ر\s*[.٫]?\s*س/.test(raw)) return 'SAR';
    if (/ج\s*[.٫]?\s*م/.test(raw)) return 'EGP';
    if (/ل\s*[.٫]?\s*ل/.test(raw)) return 'LBP';

    raw = raw.replace(/[^A-Z]/g, '');

    return ['AED', 'USD', 'SAR', 'EGP', 'LBP', 'JOD'].includes(raw)
      ? raw
      : '';
  }

  currencyFromText(text) {
    return this.normalizeCurrency(text);
  }

  parseMoneyNumber(value) {
    let text = String(value || '')
      .replace(/[٠-٩]/g, (digit) => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit))
      .replace(/[^\d.,-]/g, '');

    if (!text) return NaN;

    const lastDot = text.lastIndexOf('.');
    const lastComma = text.lastIndexOf(',');

    if (lastDot !== -1 && lastComma !== -1) {
      if (lastDot > lastComma) {
        text = text.replace(/,/g, '');
      } else {
        text = text.replace(/\./g, '').replace(',', '.');
      }
    } else if (lastComma !== -1) {
      const decimals = text.length - lastComma - 1;

      if (decimals === 1 || decimals === 2) {
        text = text.replace(/,/g, '.');
      } else {
        text = text.replace(/,/g, '');
      }
    }

    return Number.parseFloat(text);
  }

  toNumber(value) {
    const number = Number.parseFloat(String(value || '').replace(/,/g, ''));
    return Number.isFinite(number) ? number : NaN;
  }

  roundBase(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  roundDisplay(value) {
    const decimals = this._currentCurrency === 'LBP' ? 0 : 2;
    const factor = Math.pow(10, decimals);

    return Math.round((value + Number.EPSILON) * factor) / factor;
  }

  getDisplayRangeMax() {
    return this.roundDisplay(this.baseRangeMax * this._rate);
  }

  getDisplayBaseValue(baseInput) {
    if (!baseInput || baseInput.value === '') return '';

    const value = this.toNumber(baseInput.value);
    if (!Number.isFinite(value)) return '';

    return String(this.roundDisplay(value * this._rate));
  }

  updateDisplayFromBase() {
    this.displayMinInput.value = this.getDisplayBaseValue(this.baseMinInput);
    this.displayMaxInput.value = this.getDisplayBaseValue(this.baseMaxInput);

    this.displayMinInput.placeholder = '0';
    this.displayMaxInput.placeholder = String(this.getDisplayRangeMax());
  }

  updateBaseFromDisplay() {
    const minValue = this.displayMinInput.value;
    const maxValue = this.displayMaxInput.value;

    this.baseMinInput.value = minValue === ''
      ? ''
      : String(this.roundBase(this.toNumber(minValue) / this._rate));

    this.baseMaxInput.value = maxValue === ''
      ? ''
      : String(this.roundBase(this.toNumber(maxValue) / this._rate));
  }

  clampDisplayInputs() {
    const rangeMax = this.getDisplayRangeMax();

    let minValue = this.displayMinInput.value === ''
      ? null
      : this.toNumber(this.displayMinInput.value);

    let maxValue = this.displayMaxInput.value === ''
      ? null
      : this.toNumber(this.displayMaxInput.value);

    if (minValue !== null && Number.isFinite(minValue)) {
      minValue = Math.max(0, Math.min(minValue, rangeMax));
    }

    if (maxValue !== null && Number.isFinite(maxValue)) {
      maxValue = Math.max(0, Math.min(maxValue, rangeMax));
    }

    if (
      minValue !== null &&
      maxValue !== null &&
      Number.isFinite(minValue) &&
      Number.isFinite(maxValue) &&
      minValue > maxValue
    ) {
      if (document.activeElement === this.displayMinInput) {
        minValue = maxValue;
      } else {
        maxValue = minValue;
      }
    }

    if (minValue !== null && Number.isFinite(minValue)) {
      this.displayMinInput.value = String(this.roundDisplay(minValue));
    }

    if (maxValue !== null && Number.isFinite(maxValue)) {
      this.displayMaxInput.value = String(this.roundDisplay(maxValue));
    }
  }

  updateInputLimits() {
    const rangeMax = this.getDisplayRangeMax();
    const minValue = this.displayMinInput.value === ''
      ? 0
      : this.toNumber(this.displayMinInput.value);

    const maxValue = this.displayMaxInput.value === ''
      ? rangeMax
      : this.toNumber(this.displayMaxInput.value);

    this.displayMinInput.setAttribute('min', '0');
    this.displayMinInput.setAttribute(
      'max',
      String(Number.isFinite(maxValue) ? maxValue : rangeMax)
    );

    this.displayMaxInput.setAttribute(
      'min',
      String(Number.isFinite(minValue) ? minValue : 0)
    );
    this.displayMaxInput.setAttribute('max', String(rangeMax));
  }

  initializeSlider() {
    if (
      !window.jQuery ||
      !window.jQuery.fn ||
      typeof window.jQuery.fn.ionRangeSlider !== 'function'
    ) {
      return;
    }

    const $range = window.jQuery(this.rangeInput);
    const oldInstance = $range.data('ionRangeSlider');

    if (oldInstance && typeof oldInstance.destroy === 'function') {
      oldInstance.destroy();
    }

    const max = this.getDisplayRangeMax();
    const from = this.displayMinInput.value === ''
      ? 0
      : this.toNumber(this.displayMinInput.value);
    const to = this.displayMaxInput.value === ''
      ? max
      : this.toNumber(this.displayMaxInput.value);

    $range.ionRangeSlider({
      skin: 'round',
      type: 'double',
      min: 0,
      max: max,
      from: Number.isFinite(from) ? from : 0,
      to: Number.isFinite(to) ? to : max,
      step: this.getSliderStep(max),
      onChange: (data) => {
        this.updateDisplayFromSlider(data, false);
      },
      onFinish: (data) => {
        this.updateDisplayFromSlider(data, true);
      }
    });

    this._sliderInstance = $range.data('ionRangeSlider') || null;
  }

  getSliderStep(max) {
    if (this._currentCurrency === 'LBP' || max > 10000) return 1;
    return 0.01;
  }

  updateSliderRange() {
    if (!this._sliderInstance) {
      this.initializeSlider();
      return;
    }

    const max = this.getDisplayRangeMax();
    const from = this.displayMinInput.value === ''
      ? 0
      : this.toNumber(this.displayMinInput.value);
    const to = this.displayMaxInput.value === ''
      ? max
      : this.toNumber(this.displayMaxInput.value);

    this._sliderInstance.update({
      min: 0,
      max: max,
      from: Number.isFinite(from) ? from : 0,
      to: Number.isFinite(to) ? to : max,
      step: this.getSliderStep(max)
    });
  }

  updateSliderFromDisplay() {
    if (!this._sliderInstance) return;

    const max = this.getDisplayRangeMax();
    const from = this.displayMinInput.value === ''
      ? 0
      : this.toNumber(this.displayMinInput.value);
    const to = this.displayMaxInput.value === ''
      ? max
      : this.toNumber(this.displayMaxInput.value);

    this._sliderInstance.update({
      from: Number.isFinite(from) ? from : 0,
      to: Number.isFinite(to) ? to : max
    });
  }

  updateDisplayFromSlider(data, shouldSubmit) {
    const rangeMax = this.getDisplayRangeMax();
    const epsilon = Math.max(0.0001, this.getSliderStep(rangeMax) / 2);

    const isDefaultMin = Math.abs(data.from) <= epsilon;
    const isDefaultMax = Math.abs(data.to - rangeMax) <= epsilon;

    this.displayMinInput.value = isDefaultMin
      ? ''
      : String(this.roundDisplay(data.from));

    this.displayMaxInput.value = isDefaultMax
      ? ''
      : String(this.roundDisplay(data.to));

    this.updateBaseFromDisplay();
    this.updateInputLimits();

    if (shouldSubmit) {
      const eventTarget = !isDefaultMax
        ? this.baseMaxInput
        : this.baseMinInput;

      eventTarget.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }

  updateCurrencySymbols() {
    const symbols = {
      AED: 'AED',
      USD: 'USD',
      SAR: 'SAR',
      EGP: 'EGP',
      LBP: 'LBP',
      JOD: 'JOD'
    };

    const code = this._currentCurrency || 'AED';
    const symbol = symbols[code] || code;

    this._currencyItems.forEach((element) => {
      if (!element) return;

      element.innerHTML = '';

      const symbolElement = document.createElement('span');
      symbolElement.className = 'nova-filter-currency__symbol';
      symbolElement.textContent = symbol;

      element.appendChild(symbolElement);
      element.setAttribute('aria-label', code);
      element.classList.add('is-ready');
    });
  }

  updateMaxPriceInfo() {
    const wrapper = this.closest('.js-filter');
    if (!wrapper) return;

    const infoElements = wrapper.querySelectorAll(
      '.mobile-facets__info, .facets__header .facets__selected, .facets__header-vertical .facets__selected'
    );

    if (!infoElements.length) return;

    const locale = document.documentElement.lang || 'en';
    const amount = this.getDisplayRangeMax();

    const formatted = new Intl.NumberFormat(locale, {
      maximumFractionDigits: this._currentCurrency === 'LBP' ? 0 : 2
    }).format(amount);

    const message = document.documentElement.dir === 'rtl'
      ? `أعلى سعر هو ${formatted} ${this._currentCurrency}`
      : `The highest price is ${formatted} ${this._currentCurrency}`;

    infoElements.forEach((element) => {
      element.textContent = message;
    });
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

